import React, { useState, useEffect } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";

import api from "../../../api";
import { SignupUser, reset } from "../../../features/authSlice";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faAngleLeft,
  faEnvelope,
  faUnlockAlt,
  faHashtag,
  faUser,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Form,
  Card,
  Button,
  Container,
  Alert,
} from "@themesberg/react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { InputForm } from "../../../components/admin";

import BgImage from "../../../assets/img/illustrations/signin.svg";
import LogoKampus from "../../../assets/img/logo/unitomo_logo.png";
import KampusMerdeka from "../../../assets/img/logo/kampus_merdeka_logo.png";
import { getYearsList } from "../../../helpers/helper";

const Signup = () => {
  const [dataFakultas, setDataFakultas] = useState([]);
  const [dataProdi, setDataProdi] = useState([]);
  const [newUser, setNewUser] = useState({
    nim: "",
    nama: "",
    id_fakultas: "",
    id_prodi: "",
    no_hp: "",
    email: "",
    tahun_angkatan: null,
    password: "",
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isSuccess, isLoading, isError, data, message } = useSelector((state) => state.auth);

  useEffect(() => {
    const source = axios.CancelToken.source();
    const getAllResource = async () => {
      try {
        const fakultasResponse = await axios.get(`${api}/master/fakultas`, {
          cancelToken: source.token,
        });
        const fakultasFormated = fakultasResponse.data.data.map((fakultas) => ({
          value: fakultas.id,
          label: fakultas.nama,
        }));

        setDataFakultas(fakultasFormated);
      } catch (error) {}
    };

    getAllResource();
    return () => {
      source.cancel("Komponen dibongkar, membatalkan permintaan.");
    };
  }, []);

  useEffect(() => {
    // Jika newUser.id_fakultas tidak kosong, ambil data prodi
    if (newUser.id_fakultas) {
      axios
        .get(`${api}/master/prodi/get_by_fakultas_id/${newUser.id_fakultas}`)
        .then((prodiResponse) => {
          const prodiFormated = prodiResponse.data.data.map((prodi) => ({
            value: prodi.id,
            label: prodi.nama,
          }));

          setDataProdi(prodiFormated);
        });
    } else {
      // Jika newUser.id_fakultas kosong, set dataProdi menjadi array kosong
      setDataProdi([]);
    }
  }, [newUser.id_fakultas]);

  useEffect(() => {
    const userData = localStorage.getItem("userData");

    if (data?.success) {
      localStorage.setItem(
        "userData",
        JSON.stringify({
          status: data?.data?.status,
          id: data?.data?.id,
        })
      );
      localStorage.setItem("token", data?.jwt_token);
      navigate("/verification");
    } else {
      if (!userData) {
      } else if (JSON.parse(userData).status === "0") {
        navigate("/verification");
      } else if (JSON.parse(userData).status === "1") {
        navigate("/dashboard");
      }
    }
  }, [data, navigate, isSuccess]);

  const handleChange = (e) => {
    setNewUser({ ...newUser, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [isError]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(reset());
    dispatch(SignupUser(newUser));
  };

  return (
    <main>
      <Container>
        <Row className="align-items-center mt-2 gap-2">
          <Col>
            <img
              alt="logo kampus"
              src={LogoKampus}
              className="max-w-120 d-block mx-auto"
            />
          </Col>
          <Col>
            <img
              alt="logo kampus"
              src={KampusMerdeka}
              className="max-w-120 d-block mx-auto"
            />
          </Col>
        </Row>
      </Container>
      <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
        <Container>
          <p className="text-center">
            <Card.Link as={Link} to="/" className="text-gray-700">
              <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> Back to
              homepage
            </Card.Link>
          </p>
          <Row
            className="justify-content-center form-bg-image"
            style={{ backgroundImage: `url(${BgImage})` }}
          >
            <Col
              xs={12}
              className="d-flex align-items-center justify-content-center"
            >
              <div className="mb-4 mb-lg-0 bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                <div className="text-center text-md-center mb-4 mt-md-0">
                  <h3 className="mb-0">Register</h3>
                </div>
                {isError ? (
                  <>
                    <Alert variant="danger">
                      {message?.message || message}
                      {
                        message?.errors ?
                        (
                          <ul>
                            {message?.errors.map((item, i) => (
                              <li key={i}>
                                {item.msg}
                              </li>
                            ))}
                          </ul>
                        ) : null
                      }
                    </Alert>
                  </>
                ) : null}
                <Form className="mt-4" onSubmit={handleSubmit}>
                  <InputForm
                    id="nim"
                    label="NIM"
                    icon={faHashtag}
                    type="number"
                    placeholder="123456789"
                    autoFocus
                    required
                    handleChange={handleChange}
                  />
                  <InputForm
                    id="nama"
                    label="Nama"
                    icon={faUser}
                    type="text"
                    placeholder="John doe"
                    autoFocus
                    required
                    handleChange={handleChange}
                  />

                  <Form.Group className="mb-4">
                    <Form.Label>Fakultas</Form.Label>
                    <Select
                      options={dataFakultas}
                      placeholder="Pilih fakultas"
                      required
                      autoFocus
                      onChange={(e) => {
                        setNewUser({ ...newUser, id_fakultas: e.value });
                      }}
                    />
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>Prodi</Form.Label>
                    <Select
                      options={dataProdi}
                      placeholder="Pilih Prodi"
                      required
                      autoFocus
                      isDisabled={!newUser.id_fakultas}
                      onChange={(e) => {
                        setNewUser({ ...newUser, id_prodi: e.value });
                      }}
                    />
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>Tahun Angkatan</Form.Label>
                    <Select
                      options={getYearsList()}
                      placeholder="Pilih Tahun"
                      required
                      autoFocus
                      onChange={(e) => {
                        setNewUser({ ...newUser, tahun_angkatan: e.value });
                      }}
                    />
                  </Form.Group>

                  <InputForm
                    id="no_hp"
                    label="No HP"
                    icon={faPhone}
                    type="number"
                    placeholder="08511122233"
                    autoFocus
                    required
                    handleChange={handleChange}
                  />
                  <InputForm
                    id="email"
                    label="Email"
                    icon={faEnvelope}
                    type="email"
                    placeholder="example@company.com"
                    autoFocus
                    required
                    handleChange={handleChange}
                  />
                  <InputForm
                    id="password"
                    label="Password"
                    icon={faUnlockAlt}
                    type="password"
                    placeholder="Password"
                    autoFocus
                    required
                    handleChange={handleChange}
                  />
                  <InputForm
                    id="confirmPassword"
                    label="Confirm Password"
                    icon={faUnlockAlt}
                    type="password"
                    placeholder="Confirm Password"
                    autoFocus
                    required
                    handleChange={handleChange}
                  />

                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100"
                    disabled={isLoading}
                  >
                    Sign up
                  </Button>
                </Form>

                <div className="d-flex justify-content-center align-items-center mt-4">
                  <span className="fw-normal">
                    Already have an account?
                    <Card.Link as={Link} to="/" className="fw-bold">
                      {` Login here `}
                    </Card.Link>
                  </span>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};

export default Signup;
